import { DISCORD_DEVICE_TYPES, LobbyImage } from '@colonist/types';
import { CardValidatorOrdered } from './card/CardValidatorOrdered.ts';
export class PlayerValidator {
    get color() {
        return this.state.color;
    }
    get displayIcon() {
        if (!this.isActiveHumanSession) return LobbyImage.Bot;
        return this.userState.databaseIcon;
    }
    get profilePictureUrl() {
        return this.userState.profilePictureUrl;
    }
    get username() {
        return this.userState.username;
    }
    get isConnected() {
        return this.state.isConnected;
    }
    get isUser() {
        return this.userState.userId != undefined;
    }
    get isActiveHumanSession() {
        if (!this.isUser) return false;
        if (!this.isConnected) return false;
        return true;
    }
    get cardDiscardLimit() {
        return this.state.cardDiscardLimit;
    }
    get victoryPointsState() {
        return this.state.victoryPointsState;
    }
    get bankTradeRatiosState() {
        return this.state.bankTradeRatiosState;
    }
    get isLocalDiscordPlayer() {
        return this.profilePictureUrl != undefined;
    }
    get isPlayingOnDiscord() {
        if (this.userState.deviceType == undefined) return false;
        return DISCORD_DEVICE_TYPES.includes(this.userState.deviceType);
    }
    hasResourceCardsInHand(cardEnums) {
        return this.resourceCards.hasCardsInInventory(cardEnums);
    }
    constructor(newPlayerState, userState, currentUserId){
        this.state = newPlayerState;
        this.userState = userState;
        this.resourceCards = new CardValidatorOrdered(this.state.resourceCards);
        this.isCurrentUser = userState.userId != undefined && userState.userId === currentUserId;
    }
}
